import axios from 'axios';
import * as Constants from "../common/constants";
import { DisposalPlacesModel } from "../models/disposalPlaces/disposalPlaces";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { DisposalPlacesSettings } from "../models/disposalPlaces/disposalPlacesSettings";
import AuthService from './authService';

class DisposalPlacesService {
    authService = new AuthService();

    constructor() {
        axios.defaults.baseURL = `${Constants.apiUrl}/`;
        axios.defaults.headers = {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.authService.getToken()}`,
            Pragma: 'no-cache'
        }
    }

    getAllPlaces(from: number, numberOfRows: number, settings: DisposalPlacesSettings) {
        return axios({
            url: `adminDisposalPlaces/getAll/${from}/${numberOfRows}`,
            method: 'post', headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(settings)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    getDisposalPlace(id: number) {
        return axios({
            url: `adminDisposalPlaces/getById/${id}`,
            method: 'get'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    addDisposalPlace(disposalPlace: DisposalPlacesModel) {
        return axios({
            url: `adminDisposalPlaces/create`,
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(disposalPlace)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    editDisposalPlace(id: number, disposalPlace: DisposalPlacesModel) {
        return axios({
            url: `adminDisposalPlaces/update/${id}`,
            method: 'put',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            data: JSON.stringify(disposalPlace)
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }

    deleteDisposalPlace(id: number) {
        return axios({
            url: `adminDisposalPlaces/delete/${id}`,
            method: 'delete'
        })
            .then(res => res.data.data)
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error))
            )
    }
}

export default DisposalPlacesService;
